import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges, AfterViewChecked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-chat-panel',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './chat-panel.component.html',
  styleUrls: ['./chat-panel.component.scss'],
})
export class ChatPanelComponent implements OnChanges, AfterViewChecked {
  @ViewChild('messagesContainer') messagesContainer: ElementRef | undefined;

  @Input() messages: any[] = [];
  @Input() chatLoading = false;
  @Input() chatDraft = '';
  @Input() chatStatus = '';  // Real-time status from WebSocket
  @Input() headerTitle = 'P&A Insights Agent';
  @Input() headerSubtitle = '';
  @Input() mobileOpen = false;

  @Output() chatDraftChange = new EventEmitter<string>();
  @Output() sendMessage = new EventEmitter<void>();
  @Output() mobileClose = new EventEmitter<void>();

  private shouldScroll = false;

  ngOnChanges(changes: SimpleChanges): void {
    // When messages change, mark that we need to scroll
    if (changes['messages'] || changes['chatLoading']) {
      this.shouldScroll = true;
    }
  }

  ngAfterViewChecked(): void {
    // Auto-scroll to bottom when messages arrive
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  private scrollToBottom(): void {
    setTimeout(() => {
      const el = this.messagesContainer?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    }, 60);
  }

  formatMsg(text: string): string[] {
    return text.split('\n').filter((line: string) => line.trim() !== '');
  }

  onDraftChange(val: string) {
    this.chatDraft = val;
    this.chatDraftChange.emit(val);
  }

  getObjectKeys(obj: any): string[] {
    if (!obj || typeof obj !== 'object') return [];
    return Object.keys(obj);
  }
}
